<adapt-feature-guidance [configItem]="configItem">
    <p>Individuals can use actions to visualise, organise and prioritise their personal work.</p>
</adapt-feature-guidance>

<ng-container *adaptLoading="!person">
    <adapt-configure-kanban-boards [person]="person"></adapt-configure-kanban-boards>
</ng-container>
